import { TrashIcon } from "@heroicons/react/24/solid";

const DeleteButton = ({
  buttonText = "Delete",
  className,
  disabled,
  onClick,
}) => {
  return (
    <button
      value={buttonText}
      onClick={onClick}
      disabled={disabled}
      type="button"
      className={
        (disabled
          ? "cursor-not-allowed border text-white  bg-secondary "
          : "bg-secondary border-secondary text-white hover:text-white  ") +
        `hover:scale-90 flex h-5 w-16 lg:h-6 lg:w-20 lg:px-1  hover:bg-hsecondary hover:border-hsecondary flex-row shadow-md items-center justify-around text-xs3 border rounded-full px-px py-1  transition duration-500 ease select-none focus:outline-none focus:shadow-outline  ${className}`
      }
    >
      <TrashIcon className="h-4 w-4 -mr-2" />
      <div>{buttonText}</div>
    </button>
  );
};
export default DeleteButton;
